import { Component, Input, OnDestroy, OnInit } from "@angular/core";
import { Navigator } from "src/app/components/menu/navigator";
import { EventsService } from "src/app/services/event/event.service";
import { Platform } from "@ionic/angular";
import { AccountBalanceService } from "src/app/services/balance/account-balance.service";
import { Subscription } from "rxjs";

declare var window: any;

@Component({
  selector: "app-piggy-purchase-success-failure",
  templateUrl: "./piggy-purchase-success-failure.component.html",
  styleUrls: ["./piggy-purchase-success-failure.component.scss"],
})
export class PiggyPurchaseSuccessFailureComponent implements OnInit, OnDestroy {
  @Input() priceCode: string;
  @Input() message: string;
  @Input() status: boolean; // will check success or fail payment
  @Input() flag: string;
  @Input() isAuthenticated;
  @Input() price;
  @Input() chips;
  @Input() credits;
  @Input() points;
  @Input() is_premium;
  @Input() daysLeft = 6;
  @Input() dailyCollection = 5000;
  public backgroundClass = "blue-background";
  public addStars:boolean = true;


  public paymentMessage: string;
  public chipCount;
  public balanceSubscription: Subscription;
  public priceAmount;
  private basePath = './../../../assets/shop/';

  constructor(
    public events: EventsService,
    public navigator: Navigator,
    private platform: Platform,
    private balanceService: AccountBalanceService
  ) {}

  ngOnInit() {
    this.paymentMessage = this.message;
    if (this.balanceSubscription) this.unsubcribe();
    this.balanceSubscription = this.balanceService
      .getBalance()
      .subscribe((val) => {
        this.chipCount = val.PLAY.availableBalance;
      });
   
    if (this.is_premium) {
      this.backgroundClass = "purple-background"
      this.addStars = false;
    }
  }

  ionViewDidLeave() {
    this.events.publish("event:lobby:show");
    this.events.publish("event:notification:resume");
  }

  isMobileApp() {
    return this.platform.is("capacitor");
  }

  public onContinue() {
    return this.navigator.dismissAll();
  }
  private unsubcribe() {
    try {
      this.balanceSubscription.unsubscribe();
    } catch (error) {
      console.error(
        "Error while unsubscribing from balanceSubscription:",
        error
      );
    }
  }
  formatWithCommas(value) {
    if (value === undefined || value === null) {
      return "";
    }

    const number = typeof value === "string" ? parseFloat(value) : value;
    if (isNaN(number)) {
      return value;
    }

    return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }

continue(){
  return this.navigator.navigateTo('ShopPageComponent', { customModalClass: 'custom-shop-model-class-transparent', backdropDismiss: true });
}

  ngOnDestroy(): void {
    this.unsubcribe();
  }
}
